import { formFieldOnScanEdit } from '../enums/formFieldOnScanEdit';
import gridViewFieldsUtils from '../utils/gridViewFieldsUtils';
import dataFieldUtils from '../utils/dataFieldUtils';

class FormFieldOnScanEditUtils {
	getKeysValuePairToApplyOnScanEdit(inventoryForm, selectedRecord, record) {
		let selectedRecordKeys = this.getRecordKeysToApplyOnScanEdit(
			inventoryForm,
			selectedRecord,
			record
		);
		let payload = selectedRecordKeys.map((x) =>
			this.getKeyValuePair(x, selectedRecord)
		);
		return payload;
	}

	getRecordKeysToApplyOnScanEdit(inventoryForm, selectedRecord, record) {
		let selectedRecordKeys = Object.keys(selectedRecord);
		inventoryForm.FormFields.forEach((f) => {
			switch (f.OnScanEdit) {
				case formFieldOnScanEdit.AlwaysOverwriteInput: {
					break;
				}
				case formFieldOnScanEdit.AlwaysOverwriteInputExceptBlanks: {
					f.GridViewFields.forEach((gvf) => {
						let key = gridViewFieldsUtils.getFieldName(gvf);
						let linkFieldKey = dataFieldUtils.getDataFieldName(
							gvf.LinkField
						);
						if (
							selectedRecord[key] != null ||
							selectedRecord[key] != undefined ||
							selectedRecord[key] != ''
						) {
							record[key] = selectedRecord[key];
						}
						if (
							selectedRecord[key] === null ||
							selectedRecord[key] === undefined ||
							selectedRecord[key] === ''
						) {
							let keyIndex = selectedRecordKeys.indexOf(key);
							if (keyIndex > -1) {
								selectedRecordKeys.splice(keyIndex, 1);
							}
							if (linkFieldKey) {
								let linkFieldKeyIndex =
									selectedRecordKeys.indexOf(linkFieldKey);
								if (linkFieldKeyIndex > -1) {
									selectedRecordKeys.splice(
										linkFieldKeyIndex,
										1
									);
								}
							}
						}
					});
					break;
				}
				case formFieldOnScanEdit.NeverOverwriteInput: {
					f.GridViewFields.forEach((gvf) => {
						let key = gridViewFieldsUtils.getFieldName(gvf);
						let keyIndex = selectedRecordKeys.indexOf(key);
						if (keyIndex > -1) {
							selectedRecordKeys.splice(keyIndex, 1);
						}
					});
					break;
				}
				case formFieldOnScanEdit.OnlyOverwriteEmptyInput: {
					f.GridViewFields.forEach((gvf) => {
						let key = gridViewFieldsUtils.getFieldName(gvf);
						let linkFieldKey = dataFieldUtils.getDataFieldName(
							gvf.LinkField
						);
						if (record[key]) {
							let keyIndex = selectedRecordKeys.indexOf(key);
							if (keyIndex > -1) {
								selectedRecordKeys.splice(keyIndex, 1);
							}
							if (linkFieldKey) {
								let linkFieldKeyIndex =
									selectedRecordKeys.indexOf(linkFieldKey);
								if (linkFieldKeyIndex > -1) {
									selectedRecordKeys.splice(
										linkFieldKeyIndex,
										1
									);
								}
							}
						}
					});
					break;
				}
			}
		});

		return selectedRecordKeys;
	}

	getKeyValuePair(key, selectedRecord) {
		return { key: key, value: selectedRecord[key] };
	}
}
const formFieldOnScanEditUtils = new FormFieldOnScanEditUtils();
export default formFieldOnScanEditUtils;
